import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedRolePermissionToDelete: '',
  showAddAviatorPermissionsModal: false,
  showCreateAviatorPermissionForm: false,
  showSelectedRolePermissionDeleteModal: false,
};

const aviatorPermissions = createSlice({
  name: 'aviatorPermissions',
  initialState,
  reducers: {
    setShowAddAviatorPermissionsModal: (state, { payload }) => {
      state.showAddAviatorPermissionsModal = payload;
    },
    setSelectedRolePermissionToDelete: (state, { payload }) => {
      state.selectedRolePermissionToDelete = payload;
    },
    setShowCreateAviatorPermissionForm: (state, { payload }) => {
      state.showCreateAviatorPermissionForm = payload;
    },
    setShowSelectedRolePermissionDeleteModal: (state, { payload }) => {
      state.showSelectedRolePermissionDeleteModal = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: aviatorPermissionsReducer } = aviatorPermissions;
export const {
  setShowAddAviatorPermissionsModal,
  setSelectedRolePermissionToDelete,
  setShowCreateAviatorPermissionForm,
  setShowSelectedRolePermissionDeleteModal,
} = aviatorPermissions.actions;
